import { Grid, Box } from '@mui/material';
import React, { useEffect } from "react";
import SiteDetailsCard from "./cards/SiteDetailsCard";
import ActivityCard from "./cards/ActivityCard";
import InvoicesCard from "./cards/InvoicesCard";
import ConsultingCard from "./cards/ConsultingCard";
import ProjectsCard from "./cards/ProjectsCard";
import SiteToolsCard from './cards/SiteToolsCard';
import StyledPage from '../../common/StyledPage';
import { observer } from 'mobx-react-lite';
import { withRouter } from 'react-router';
import ResourcesCard from './cards/ResourcesCard';
import GoogleDriveCard from './cards/GoogleDriveCard';
import EndOfYearAccountingCard from './cards/EndOfYearAccountingCard';

const WebsiteViewComponent = ({ match }) => {

  return (
    <StyledPage>
      <Grid container>
        <Grid item xs={12}>
          <ActivityCard siteId={match.params.site_id} />
        </Grid>
        <Grid item xs={12}>
          <ConsultingCard siteId={match.params.site_id} />
        </Grid>
        <Grid item xs={12}>
          <EndOfYearAccountingCard siteId={match.params.site_id} />
        </Grid>
        <Grid item xs={12}>
          <GoogleDriveCard siteId={match.params.site_id} />
        </Grid>
        <Grid item xs={12}>
          <ProjectsCard siteId={match.params.site_id}/>
        </Grid>
        <Grid item xs={12}>
          <InvoicesCard siteId={match.params.site_id} />
        </Grid>
        <Grid item xs={12}>
          <ResourcesCard siteId={match.params.site_id} />
        </Grid>
      </Grid>
    </StyledPage>
  )
}

export default withRouter(WebsiteViewComponent);
